import '../Styles.css';
import { jwtDecode } from "jwt-decode";
import { Middleware, MiddlewareProvider } from './Middleware';
import axios from 'axios';
import React from 'react';
import { TokenValidateExpiration } from './Token';

const token = localStorage.getItem("token");
var decode = "";
var rfc = "";

if (token) {
    decode = jwtDecode(token);
    rfc = decode.rfc;
}

function PoviderContactFilter(TipoContacto) {
    //alert(TipoContacto);
    document.getElementById("contactSelect"+TipoContacto).style.display = 'none';
}

function ProviderContactSave() {
    document.getElementById("ChgA").style.display = "block";
    document.getElementById("BtnA").style.display = "none";
    document.getElementById("messageError").innerHTML = "";
    //const [contacts, setContacts] = React.useState([]);

    //React.useEffect(() => {
        axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/contact/save/'+token, {
            IdUser: decode.id,
            Nombres: document.getElementById("Nombres").value,     
            Apellidos: document.getElementById("Apellidos").value,  
            TipoContacto: document.getElementById("TipoContacto").value,
            Puesto: document.getElementById("Puesto").value, 
            CodigoPais: document.getElementById("CodigoPais").value,
            Telefono: document.getElementById("Telefono").value, 
            Extension: document.getElementById("Extension").value, 
            TipoTelefono: document.getElementById("TipoTelefono").value,
            Email: document.getElementById("Email").value,     
            TipoCorreo: document.getElementById("TipoCorreo").value,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        window.scrollTo(0, 0);
        console.log(response)
        document.getElementById("ChgB").style.display = "none";
        document.getElementById("messageSuccess").style.display = "block";
        document.getElementById("messageSuccess").innerHTML = "Contacto guardado exitosamente, recargando la pagina, por favor espere...";
        setTimeout(() => {
            window.location.href = '/proveedor-contactos';
        }, 3000);
        return;
    }
    )
    .catch(error =>{
        console.log(error)
        document.getElementById("ChgA").style.display = "none";
        document.getElementById("BtnA").style.display = "inline-block";
        document.getElementById("messageError").innerHTML = "No se pudo guardar el contacto, por favor intente de nuevo";
    });
    //}, []);
}

function ProviderRemoveContact(id) {
    if(window.confirm("¿Estás seguro de eliminar el contacto?") == false){
        return;
    }
    axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/contacts/delete/'+token, {
        IdContact: id,
        IdUser: decode.id,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    ).then(response => {
        window.scrollTo(0, 0);
        document.getElementById("ChgB").style.display = "none";
        document.getElementById("messageSuccess").style.display = "block";
        document.getElementById("messageSuccess").innerHTML = "Contacto eliminado exitosamente, recargando la pagina, por favor espere...";
        setTimeout(() => {
            window.location.href = '/proveedor-contactos';
        }, 3000);
    })
    .catch(error => {
        //
    });
}

function ProviderFinishContacts() {
    document.getElementById("error").innerHTML = "";

    document.getElementById("ChgB").style.display = "block";
    document.getElementById("BtnB").style.display = "none";
    
    if (document.getElementById("TipoContactoFA") && document.getElementById("TipoContactoAP") && document.getElementById("TipoContactoCP") && document.getElementById("TipoContactoOC")) {
        window.location.href = '/proveedor-cuestionarios';
    } else {
        document.getElementById("ChgB").style.display = "none";
        document.getElementById("BtnB").style.display = "inline-block";
        window.scrollTo(0, 0);
        document.getElementById("error").innerHTML = "Se debe agrergar por lo menos un contacto de *COMPLEMENTO DE PAGO, *FACTURACIÓN, *AVISO A PAGO y uno de *CONTACTO COMERCIAL para continuar";
    }    
}

function ProviderContacts() {
    Middleware();
    MiddlewareProvider();

    const token = localStorage.getItem("token");
    TokenValidateExpiration(token);

    ///api/provider/contacts/get/
    const [contacts, setContacts] = React.useState([]);
    const [contactos, setContactos] = React.useState([]);
    const [contactosRestantes, setContactosRestantes] = React.useState([]);
    const [puesto, setPuesto] = React.useState([]);
    const [codigoPais, setCodigoPais] = React.useState([]);
    const [telefono, setTelefono] = React.useState([]);
    const [correo, setCorreo] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/contacts/get/' + decode.id +'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        console.log(response);
        setContacts(response.data.Contacts);
        setContactos(response.data.Contacto);
        setContactosRestantes(response.data.ContactosRestantes);
        setPuesto(response.data.Puesto);
        setCodigoPais(response.data.CodigoPais);
        setTelefono(response.data.Telefono);
        setCorreo(response.data.Correo);
        
    });
    }, []);
    
    return (
        <div className='Container'>
            <div className='Navbar'>
                <div>
                    <h5 className='text-white'>Portal de proveedores</h5>
                </div>
            </div>
            <div className='Section'>
                <div className='Header'>
                    <div className="text-center">
                        <div className='row'>
                            <div className='col-md-6 Text-left'>
                                <label className='mt-1 Text-Gray'><b>Usuario: </b>
                                    {  
                                        rfc
                                    }
                                </label>
                            </div>
                            <div className='col-md-6 Text-right'>
                                <a href='/logout'>
                                    <label>
                                        Cerrar sesión
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fillRule="currentColor" className="bi bi-box-arrow-right m-1" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
                                            <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
                                        </svg>
                                    </label>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='Article'>
                    <div className="text-center">
                        <h1 className='Text-Red'>Contactos</h1>
                        <br></br>
                        <label className='text-gray'>
                            Es necesario ingresar los contactos de * FACTURACIÓN, * AVISO DE PAGO, * COMPLEMENTO DE PAGO y * CONTACTO COMERCIAL.
                        </label>
                        <br></br>
                        <label id="error" className='Text-Red'></label>
                        <br></br>
                        <br></br>
                        <form action={ProviderContactSave}>
                            <div className='d-flex justify-content-center'>
                                <label id='messageError' className='Error-Notification'></label>
                            </div>
                            <div className='d-flex justify-content-center'>
                                <label id='messageSuccess' className='Success-Notification'></label>
                            </div>
                            <p id="messageError" className='Text-Red'></p>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div>
                                            <label className='Text-Red'>*</label><label>Nombres</label>
                                            <br></br>
                                            <input name="Nombres" type="input" id="Nombres" className="form-control" pattern="[áéíóúa-zÁÉÍÓÚA-ZñÑ\s]+" required></input>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div>
                                            <label className='Text-Red'>*</label><label>Apellidos</label>
                                            <br></br>
                                            <input name="Apellidos" type="input" id="Apellidos" className="form-control" pattern="[áéíóúa-zÁÉÍÓÚA-ZñÑ\s]+" required></input>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div>
                                            <label className='Text-Red'>*</label><label>Tipo de Contacto</label>
                                            <br></br>
                                            <select name="TipoContacto" key="TipoContacto" id="TipoContacto" aria-label="Default select example" className="form-select" required>
                                                <option key="0" value="">Selecciona...</option>
                                                
                                                {
                                                    contactosRestantes.map(itemA => (
                                                            <option id={"contactSelect"+itemA.Codigo} key={"contactSelect"+itemA.Codigo} value={itemA.Codigo}>{itemA.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div>
                                            <label className='Text-Red'>*</label><label>Puesto</label>
                                            <br></br>
                                            <select name="Puesto" id="Puesto" aria-label="Default select example" className="form-select" required>
                                                <option key="0" value="">Selecciona...</option>
                                                {
                                                    puesto.map(item => (
                                                        <option key={item.Codigo} value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div>
                                            <label className='Text-Red'>*</label><label>Código País</label>
                                            <br></br>
                                            <select name="CodigoPais" id="CodigoPais" aria-label="Default select example" className="form-select" required>
                                                <option key="0" value="">Selecciona...</option>
                                                {
                                                    codigoPais.map(item => (
                                                        <option key={item.Codigo} value={item.Codigo}>{item.Pais + " + " + item.Codigo}</option>
                                                    ))
                                                } 
                                            </select>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div>
                                            <label className='Text-Red'>*</label><label>Teléfono</label>
                                            <br></br>
                                            <input name="Telefono" type="input" id="Telefono" className="form-control" pattern="[0-9]+" minLength={10} maxLength={10} required></input>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div>
                                            <label>Extensión (Opcional)<span></span></label>
                                            <br></br>
                                            <input name="Extension" type="input" id="Extension" className="form-control" pattern="[áéíóúa-zÁÉÍÓÚA-ZñÑ0-9\s]+" minLength={3} maxLength={3}></input>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div>
                                            <label className='Text-Red'>*</label><label>Tipo de Teléfono</label>
                                            <br></br>
                                            <select name="TipoTelefono" id="TipoTelefono" aria-label="Default select example" className="form-select" required>
                                                <option key="0" value="">Selecciona...</option>
                                                {
                                                    telefono.map(item => (
                                                        <option key={item.Codigo} value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div>
                                            <label className='Text-Red'>*</label><label>E-Mail</label>
                                            <br></br>
                                            <input name="Email" id="Email" type="email" className="form-control" required></input>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div>
                                            <label className='Text-Red'>*</label><label>Tipo de Correo</label>
                                            <br></br>
                                            <select name="TipoCorreo" id="TipoCorreo" aria-label="Default select example" className="form-select" required>
                                                <option key="0" value="">Selecciona...</option>
                                                {
                                                    correo.map(item => (
                                                        <option key={item.Codigo} value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <i id="ChgA"className="fa fa-spinner fa-spin Chg"></i>
                            <input id='BtnA' type='submit' value='Guardar' className='Button-Style'></input>
                            <br></br>
                            <br></br>
                        </form>
                        {
                            contacts 
                            &&
                            <div>
                                <br></br>
                                <br></br>
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th scope="col">Nombre</th>
                                            <th scope="col">Tipo de contacto</th>
                                            <th scope='col'>Puesto</th>
                                            <th scope='col'>Teléfono</th>
                                            <th scope="col">Email</th>
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            contacts 
                                            &&
                                            contacts.map(item => (
                                                <tr id={"TipoContacto"+item.TipoContacto} key={"TipoContacto"+item.TipoContacto} value={item.TipoContacto}>
                                                    <td>
                                                        {item.Nombres+" "+item.Apellidos}
                                                    </td>
                                                    <td>
                                                        {
                                                            contactos.map(itemTC =>(
                                                                item.TipoContacto == itemTC.Codigo
                                                                &&
                                                                itemTC.Nombre
                                                            ))
                                                        }
                                                    </td>
                                                    <td>
                                                        {
                                                            puesto.map(itemTP => (
                                                                item.Puesto == itemTP.Codigo
                                                                &&
                                                                itemTP.Nombre
                                                            ))
                                                        }
                                                    </td>
                                                    <td>{item.Telefono}</td>
                                                    <td>{item.Email}</td>
                                                    <td>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16" onClick={() => ProviderRemoveContact(item.Id)}>
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                                    </svg>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                <br></br>
                                <input id='BtnB' type='submit' value='Continuar' className='Button-Style' onClick={ProviderFinishContacts}></input>
                            </div>
                        }
                        <i id="ChgB"className="fa fa-spinner fa-spin Chg"></i>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProviderContacts;